import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import Creators from '../assets/icons/creative.png';
import AddToList from '../assets/icons/edit-list-icon.svg';
import Support from '../assets/icons/ai-chatting.svg';
import UserProfileDropdown from './UserProfileDropdown';
import '../styles/Header.css';

import Dashboard from '../assets/icons/Dashboard_24px.png';
import ShortListed from '../assets/icons/Shortlist_24px.png';
import ActivityLogSvg from '../assets/icons/ActivityLog_24px.png';
import Campaign from '../assets/icons/Campaign_24px.png';


function Header() {
    const location = useLocation();
    const [currentMenu, setCurrentMenu] = useState('Dashboard');
    const [currentLogo, setCurrentLogo] = useState(Dashboard);


    useEffect(() => {
        if (location.pathname === '/') {
            setCurrentMenu('Dashboard');
            setCurrentLogo(Dashboard)
        }
        else if (location.pathname === '/campaigns') {
            setCurrentMenu('Campaign List');
            setCurrentLogo(Campaign)
        } else if (location.pathname === '/details') {
            setCurrentMenu('Info');
            setCurrentLogo(Creators)
        } else if (location.pathname === '/activitylog') {
            setCurrentMenu('Activity Log');
            setCurrentLogo(ActivityLogSvg)
        } else if (location.pathname === '/shortlisted') {
            setCurrentMenu('Shortlists');
            setCurrentLogo(AddToList)
        } else if (location.pathname === '/support') {
            setCurrentMenu('SocialJet GPT');
            setCurrentLogo(Support)
        }

    }, [location.pathname]);

    return (
        <header className="d-flex align-items-center bg-light bg-opacity-80 p-3 backdrop-blur-xl z-990 header-options">
            <div className="d-flex align-items-baseline me-auto">
                <>
                    <h4 className="mb-0">{currentMenu}</h4>
                </>
            </div>
            <div className='user-profile-menu'>
                <UserProfileDropdown />
            </div>
        </header>
    );
}

export default Header;